import * as React from 'react';

const StrikethroughSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="strikethrough_svg__eds-icon--strikethrough_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g
            id="strikethrough_svg__eds-icon--strikethrough_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
        >
            <path d="M15.9 14c1.3.9 1.6 1.8 1.6 3.2 0 2.4-2.1 4-5.3 4-2.9 0-5-1.5-5.8-4.5l-1.3.3c.8 3.3 3.4 5.4 7.1 5.4 3.7 0 6.7-2 6.7-5.3 0-1.3-.3-2.3-.9-3.1h-2.1zM15 12c-.6-.3-1.3-.5-2.1-.8C8.3 9.7 7 8.9 7 6.5c0-2 1.8-3.6 4.6-3.6 2.6 0 4.4 1.1 5.3 3.9l1.3-.4c-.8-2.8-2.9-4.7-6.6-4.7-3.5 0-6 2.3-6 4.9 0 2.9 1.6 4.1 5.4 5.4H5v1h16v-1h-6z" />
        </g>
    </svg>
);

StrikethroughSvg.displayName = 'StrikethroughSvg';
export default StrikethroughSvg;
